import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ApiKey, ApiKeyService } from '../../services/api-key.service';
import { AlertsService } from '../../services/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../services/user-service.service';

@Component({
  selector: 'app-api-key-manager',
  templateUrl: './api-key-manager.component.html',
  styleUrls: ['./api-key-manager.component.scss']
})
export class ApiKeyManagerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() group: number;

  apiKeys: ApiKey[] = [];
  loading = false;
  creating = false;
  newlyCreatedKey: ApiKey | null = null;
  confirmDeleteId: string | null = null;
  secretCopied = false;

  componentSubscriptions: any = {};

  constructor(
    private apiKeyService: ApiKeyService,
    private alertService: AlertsService,
    private translateService: TranslateService,
    public userService: UserService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.group && this.group) {
      this.loadApiKeys();
    }
  }

  ngOnDestroy() {
    Object.keys(this.componentSubscriptions).forEach(
      key => this.componentSubscriptions[key].unsubscribe()
    );
  }

  loadApiKeys() {
    this.loading = true;
    this.componentSubscriptions.loadApiKeys$ = this.apiKeyService.list(this.group).subscribe(
      (keys) => {
        this.apiKeys = keys;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.alertService.setAlert(undefined, error);
      }
    );
  }

  createApiKey() {
    this.creating = true;
    this.newlyCreatedKey = null;
    this.componentSubscriptions.createApiKey$ = this.apiKeyService.create(this.group).subscribe(
      (key) => {
        this.creating = false;
        this.newlyCreatedKey = key;
        this.loadApiKeys();
        const message = this.translateService.instant('__apiKeyCreatedSuccessfully');
        this.alertService.setAlert({ type: 'success', message });
      },
      (error) => {
        this.creating = false;
        this.alertService.setAlert(undefined, error);
      }
    );
  }

  requestDelete(apiKeyId: string) {
    this.confirmDeleteId = apiKeyId;
  }

  cancelDelete() {
    this.confirmDeleteId = null;
  }

  confirmDelete(apiKeyId: string) {
    this.componentSubscriptions.deleteApiKey$ = this.apiKeyService.revoke(apiKeyId, this.group).subscribe(
      () => {
        this.confirmDeleteId = null;
        if (this.newlyCreatedKey && this.newlyCreatedKey.api_key_id === apiKeyId) {
          this.newlyCreatedKey = null;
        }
        this.loadApiKeys();
        const message = this.translateService.instant('__apiKeyRevokedSuccessfully');
        this.alertService.setAlert({ type: 'success', message });
      },
      (error) => {
        this.confirmDeleteId = null;
        this.alertService.setAlert(undefined, error);
      }
    );
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.secretCopied = true;
      setTimeout(() => this.secretCopied = false, 2000);
    });
  }

  dismissNewKey() {
    this.newlyCreatedKey = null;
  }
}
